/**
 * map for the status code and icon style name
 */
export const statusConfig = {
  124: 'statusPaused_icon', // UserPaused
  126: 'statusPaused_icon', // BudgetPaused
  127: 'statusPaused_icon', // BudgetUserPaused
  123: 'statusDeleted_icon', // Deleted
  8: 'statusSuspended_icon', // Suspended
  121: 'statusEnabled_icon', // Active
  UserPaused: 'statusPaused_icon',
  BudgetPaused: 'statusPaused_icon',
  BudgetUserPaused: 'statusPaused_icon',
  Deleted: 'statusDeleted_icon',
  Suspended: 'statusSuspended_icon',
  Active: 'statusEnabled_icon',
  AccountActive: 'iconba iconba-Completed',
  AccountError: 'iconba iconba-Error',
  InProgress: 'statusPaused_icon',
  Paused: 'statusPaused_icon',
  Draft: 'statusDraft_icon',
  Expired: 'statusPaused_icon',
  CampaignUserPaused: 'statusPaused_icon',
  CampaignBudgetPaused: 'statusPaused_icon',
  CampaignBudgetUserPaused: 'statusPaused_icon',
  PrivacyPending: 'statusPending_icon',
  TargetingTooNarrow: 'statusPending_icon',
};
